var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsStarAggiornamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 373.38 373.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #1d71b5;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 186.69,
    cy: 186.69,
    r: 186.69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Street_Right",
    "data-name": "Street Right"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 186.69,
    cy: 186.69,
    r: 186.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.69 53.45 217.39 147.93 316.73 147.93 236.36 206.32 267.06 300.81 186.69 242.41 106.32 300.81 137.02 206.32 56.65 147.93 155.99 147.93 186.69 53.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsStarAggiornamento);
export default __webpack_public_path__ + "static/media/news-star-aggiornamento.54dc277eeb6a0924d5712278ac4e56f8.svg";
export { ForwardRef as ReactComponent };